<template>
  <fragment>
    <button
        v-bind="$attrs"
        v-if="!to && !href"
        :disabled="showIndicator || disabled"
        :class="`c-button btn btn-${theme} btn-${size} ${className}`"
        @click="$emit('click')"
        :type="type"
    >
      <span :style=" showIndicator ? 'opacity: 0;' : 'opacity: 1;'">
        <i v-if="icon" :class="`fa-regular ${icon}`"></i>
      </span>
      <span :style=" showIndicator ? 'opacity: 0;' : 'opacity: 1;'">
       <slot></slot>
      </span>
      <div class="button-preloader" v-if="showIndicator">
        <span class="button-preloader__dot"/>
        <span class="button-preloader__dot"/>
        <span class="button-preloader__dot"/>
      </div>
    </button>

    <a
        v-bind="$attrs"
        v-if="href"
        :href="href"
        :class="`c-button btn btn-${theme} btn-${size} ${className}`"
        @click="$emit('click')"
        :type="type"
    >
      <i v-if="icon" :class="`fa-regular ${icon}`"></i>
      <slot></slot>
    </a>

    <router-link
        v-bind="$attrs"
        v-if="to"
        :to="to"
        :class="`c-button btn btn-${theme} btn-${size} ${className}`"
        @click="$emit('click')"
        :type="type"
    >
      <i v-if="icon" :class="`fa-regular ${icon}`"></i>
      <slot></slot>
    </router-link>
  </fragment>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'success'
    },
    size: {
      type: String,
      default: 'md'
    },
    type: {
      type: String,
      default: 'button'
    },
    to: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    showIndicator: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  &:disabled {
    cursor: not-allowed;
  }
}

.c-button {
  position: relative;
}

.button-preloader {
  display: flex;
  position: absolute;
  top: calc(50% - 6px);
  left: calc(50% - 18px);

  .button-preloader__dot {
    border-radius: 6px;
    display: block;
    width: 6px;
    height: 6px;
    margin: 3px;
    background-color: white;

    &:first-child {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-iteration-count: infinite;
    }

    &:nth-child(2) {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-delay: 0.1s;
      animation-iteration-count: infinite;
    }

    &:last-child {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-delay: 0.2s;
      animation-iteration-count: infinite;
    }
  }

  @keyframes run-dots {
    from {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
}
</style>
